import clsx from 'classnames';
import React, { FC } from 'react';

import { PresenterType } from '~/templates/L2EventPage';

import Presenter from '../Presenter/Presenter';

interface PresentersListProps {
  presenters: PresenterType[];
  className?: string;
}

const PresentersList: FC<PresentersListProps> = ({
  presenters,
  className = '',
}) => (
  <div className={clsx('presenters-list', className)}>
    {presenters.map(
      ({ presenter_last_name, presenter_name, presenter_image }) => (
        <Presenter
          color="white"
          key={`${presenter_name} ${presenter_last_name}`}
          alt={presenter_image?.alt}
          avatarUrl={presenter_image?.image?.url}
          name={`${presenter_name} ${presenter_last_name}`}
        />
      )
    )}
  </div>
);

export default PresentersList;
